import CheckoutReviewVendorOrderItemSection from "@/app/checkout/(squeeze)/review/checkoutReviewVendorOrderItemSection";
import CheckoutReviewVendorOrderSectionFooter from "@/app/checkout/(squeeze)/review/checkoutReviewVendorOrderSectionFooter";
import CheckoutReviewVendorOrderSectionHeader from "@/app/checkout/(squeeze)/review/checkoutReviewVendorOrderSectionHeader";
import { CheckoutOrder } from "@/fetch/getCheckoutResponse";
import styles from "./checkoutReviewVendorOrderSection.module.scss";

export default function CheckoutReviewVendorOrderSection({
  shoppingCartVendorOrder,
  isConfirmationPage,
}: CheckoutReviewVendorOrderSectionProps) {
  const { products } = shoppingCartVendorOrder;
  return (
    <section className={styles.VendorOrderSection}>
      {shoppingCartVendorOrder && (
        <CheckoutReviewVendorOrderSectionHeader shoppingCartVendorOrder={shoppingCartVendorOrder} />
      )}
      {products?.map((product, index) => (
        <CheckoutReviewVendorOrderItemSection key={index} product={product} isConfirmationPage={isConfirmationPage} />
      ))}
      {shoppingCartVendorOrder && (
        <CheckoutReviewVendorOrderSectionFooter shoppingCartVendorOrder={shoppingCartVendorOrder} />
      )}
    </section>
  );
}
export type CheckoutReviewVendorOrderSectionProps = {
  shoppingCartVendorOrder: CheckoutOrder;
  isConfirmationPage?: boolean;
};
